import { useCallback, useEffect, useState } from "react";
import { shouldShowLocalBackendUnavailableBanner } from "./resolve";
import {
  clearLocalBackendUnavailableNotice,
  readLocalBackendUnavailableDetail,
  subscribeLocalBackendUnavailableNotice
} from "./storage";

export function useLocalBackendUnavailableBanner() {
  const [visible, setVisible] = useState(shouldShowLocalBackendUnavailableBanner);

  useEffect(() => {
    return subscribeLocalBackendUnavailableNotice(() => {
      setVisible(shouldShowLocalBackendUnavailableBanner());
    });
  }, []);

  const dismiss = useCallback(() => {
    clearLocalBackendUnavailableNotice();
  }, []);

  return {
    visible,
    detail: visible ? readLocalBackendUnavailableDetail() : null,
    dismiss
  };
}
